
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "LogEvent",
        "possibleTypes": [
          {
            "name": "GenericEvent"
          },
          {
            "name": "DeviceStateEvent"
          },
          {
            "name": "DeviceConnectEvent"
          },
          {
            "name": "DeviceShareEvent"
          },
          {
            "name": "LicenseUpdatedEvent"
          }
        ]
      }
    ]
  }
};
      export default result;
    